// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../shared/Dialog.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styles for buttons at top left of map (i.e. tips menu, refresh button etc) */
.dw64szqOPwkz2Dcqjcf2 {
    position: absolute;
    top: calc(105px + 2.5rem + 67pt);
    left: 10px;
    z-index: 4;
    display: flex;
    flex-flow: column nowrap;
    gap: 1rem;
}

.XAMUv9oFmD588x2MuT_5 {
    all: unset;
    height: 2.25rem;
    width: 2.25rem;
    background-color: white;
    border-radius: 3px;
    background-image: var(--icon-background-image);
    background-size: var(--icon-background-size, 17px);
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    box-shadow: var(--map-button-box-shadow);
}

.XAMUv9oFmD588x2MuT_5:hover {
    filter: brightness(0.95);
}

.XAMUv9oFmD588x2MuT_5:focus {
    outline: var(--focus-outline);
    filter: brightness(0.95);
}

/* Popup containers from buttons */

.sWxDV5Mxo83uhhN36nQa {
    max-width: unset;
    width: min(75vw, clamp(320px, 25vw, 390px));
    margin-top: calc(-2.5rem - 67pt);
    margin-left: 54px;
    position: absolute;
}

/* Header area inside the content panel */
.e5vPIhwJ_kZn3iQr_CQv {
}

.vQmjdBh8MMU5qOy5G187 {
}

.srezwaiBhQGqoglszLOz {
}

.mMo_zw8VV5i566KQEspH {
    display: flex;
    flex-direction: column;
    max-height: 50vh;
}

.yza4dnstRW28JZY7gK46 {
}`, "",{"version":3,"sources":["webpack://./../core/components/map-buttons/MapButtons.module.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;IACI,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,8CAA8C;IAC9C,kDAAkD;IAClD,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA,kCAAkC;;AAElC;IAEI,gBAAgB;IAChB,2CAA2C;IAC3C,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;IAEI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;AAEA","sourcesContent":["/* Shared styles for buttons at top left of map (i.e. tips menu, refresh button etc) */\r\n.mapButtonsContainer {\r\n    position: absolute;\r\n    top: calc(105px + 2.5rem + 67pt);\r\n    left: 10px;\r\n    z-index: 4;\r\n    display: flex;\r\n    flex-flow: column nowrap;\r\n    gap: 1rem;\r\n}\r\n\r\n.mapButtonIcon {\r\n    all: unset;\r\n    height: 2.25rem;\r\n    width: 2.25rem;\r\n    background-color: white;\r\n    border-radius: 3px;\r\n    background-image: var(--icon-background-image);\r\n    background-size: var(--icon-background-size, 17px);\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    cursor: pointer;\r\n    box-shadow: var(--map-button-box-shadow);\r\n}\r\n\r\n.mapButtonIcon:hover {\r\n    filter: brightness(0.95);\r\n}\r\n\r\n.mapButtonIcon:focus {\r\n    outline: var(--focus-outline);\r\n    filter: brightness(0.95);\r\n}\r\n\r\n/* Popup containers from buttons */\r\n\r\n.mapContentContainer {\r\n    composes: container from '@shared/Dialog.module.css';\r\n    max-width: unset;\r\n    width: min(75vw, clamp(320px, 25vw, 390px));\r\n    margin-top: calc(-2.5rem - 67pt);\r\n    margin-left: 54px;\r\n    position: absolute;\r\n}\r\n\r\n/* Header area inside the content panel */\r\n.mapButtonHeaderContainer {\r\n    composes: headerContainer from '@shared/Dialog.module.css';\r\n}\r\n\r\n.mapButtonHeader {\r\n    composes: headerText from '@shared/Dialog.module.css';\r\n}\r\n\r\n.closeIcon {\r\n    composes: closeButton from '@shared/Dialog.module.css';\r\n}\r\n\r\n.mapButtonContentContainer {\r\n    composes: contentContainer from '@shared/Dialog.module.css';\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: 50vh;\r\n}\r\n\r\n.mapButtonContent {\r\n    composes: content from '@shared/Dialog.module.css';\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapButtonsContainer": `dw64szqOPwkz2Dcqjcf2`,
	"mapButtonIcon": `XAMUv9oFmD588x2MuT_5`,
	"mapContentContainer": `sWxDV5Mxo83uhhN36nQa ${___CSS_LOADER_ICSS_IMPORT_0___.locals["container"]}`,
	"mapButtonHeaderContainer": `e5vPIhwJ_kZn3iQr_CQv ${___CSS_LOADER_ICSS_IMPORT_0___.locals["headerContainer"]}`,
	"mapButtonHeader": `vQmjdBh8MMU5qOy5G187 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["headerText"]}`,
	"closeIcon": `srezwaiBhQGqoglszLOz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["closeButton"]}`,
	"mapButtonContentContainer": `mMo_zw8VV5i566KQEspH ${___CSS_LOADER_ICSS_IMPORT_0___.locals["contentContainer"]}`,
	"mapButtonContent": `yza4dnstRW28JZY7gK46 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["content"]}`
};
module.exports = ___CSS_LOADER_EXPORT___;
